import { fetchMarketplaceProductAvailabilities } from "@/api/services/marketplace-detail";
import { mapMarketplaceAvailabilitiesToBookingDates } from "./map-marketplace-availabilities";
import { getThreeMonthChunkRange } from "@/lib/marketplace/constants";
import { mapProductAvailabilitiesResponse } from "@/lib/marketplace/marketplace-detail-utils";
import type {
  ActivityPricingCategory,
  BookingDate,
} from "@/types/api/group-tour-details";

/** Fetches a 3-calendar-month availability chunk from `chunkStart`. */
export async function fetchMarketplaceAvailabilityChunk(
  productUid: string,
  chunkStart: Date,
  pricingCategories: ActivityPricingCategory[]
): Promise<BookingDate[]> {
  const { start, end } = getThreeMonthChunkRange(chunkStart);

  const rawResponse = await fetchMarketplaceProductAvailabilities(
    productUid,
    start,
    end
  );

  const normalized = mapProductAvailabilitiesResponse(rawResponse);
  return mapMarketplaceAvailabilitiesToBookingDates(
    normalized,
    pricingCategories
  );
}
